import { reatomAsync } from "@reatom/async";
import { API } from "src/api";
import { withIsLoadingAtom } from "src/common/pipes";

export const logoutRequest = reatomAsync(
  () => API.authApi.authControllerLogout(),
  "logoutRequest",
).pipe(withIsLoadingAtom());
